import Vue from 'vue/dist/vue';
import moment from 'moment';

export default {

    user: {
        authenticated: false,
        id: 0,
        firstName: '',
        lastName: '',
        email: '',
        trialEndDate: '',
        memberType: '',
        tags: [],
        projectTags: [],
        contactTags: [],
        subscription: {
            plan: {
                base_price: 0,
                additional_vertical_market_cost: 0,
                additional_state_cost: 0,
                description: '',
                name: '',
                coverage_limit: 0,
                coverage_state: 1,
                users_count: 0,
            }
        },
        allowDownload: false,
        allowShare: false,
        allowDirectory: false,
        displaySubscriptionNudge: false,
    },
    
    login (creds, callback) {

        Vue.http.post('/Login', creds)
            .then((response) => {

                var token = response.body.data.accessToken;
                this.setToken(token);
                this.getUserInfo(token);

                callback(null, true);

            }, (response) => {

                var data = response.data;
                if (data.message) {
                    callback(data.message);
                }
                else {
                    callback("Incorrect email or password combination. Please try again.");
                }
            });
    },
    
    forgotPassword (email, callback) {

        Vue.http.post('/ForgotPassword', { email: email })
            .then((response) => {
                callback(response.body.data, !response.body.error);
            }, (response) => {
                callback(response.body.data, false);
            });
    },
    
    resetPassword (params, callback) {

        Vue.http.post('/ResetPassword', params)
            .then((response) => {
                callback(response.body.data, !response.body.error);
            }, (response) => {
                callback(response.body.data, false);
            });
    },
    
    getUserInfo (token) {
        
        if (this.noHttpsToken()) {
            return false;
        }
        
        token = token || this.getToken();

        if (!token) {
            return false;
        }
        
        Vue
            .http
            .get(Vue.baseUrl+'/Users/Me')
            .then((response) => {

                var user = response.data.data;
                this.user.id = user.id;
                this.user.firstName = user["first_name"];
                this.user.lastName = user["last_name"];
                this.user.email = user.email;
                this.user.authenticated = true;
                this.user.tags = user.tags;
                this.user.subscription = user.subscription;
                this.user.allowDownload = user.allow_download;
                this.user.allowShare = user.allow_share;
                this.user.allowDirectory = user.allow_directory;
                this.user.allowCompanySearch = user.allow_companysearch;
                this.user.memberType = user.member_type;
                if (user.subscription.trial_end_date != null && user.subscription.trial_end_date != '') {
                    var date = user.subscription.trial_end_date;
                    date = date.slice(0, -9);
                    this.user.trialEndDate = date;
                }
                this.user.projectTags = user.tags.filter(function(val) { return val.tag_type == 1 });
                this.user.contactTags = user.tags.filter(function(val) { return val.tag_type == 2 });
    
            }, (response) => {
                console.log("did fail");
                if (response.status == 403) {
                    this.logout();
                    console.log("did fail to go");
                }
            });
    },

    hasRole (role) {
        return false;
    },
    
    checkAuth () {
        this.getUserInfo();
    },
    
    isLoggedIn () {
        return this.getToken();  
    },
    
    decrementRemainingProjects () {
        // This used to decrement, but now we just reload the user data to get the remaining projects.
        if (this.user.memberType === 'Free Trial') {
            Vue
                .http
                .get(Vue.baseUrl+'/Users/Me')
                .then((response) => {
                    const user = response.data.data;
                    this.user.subscription.remaining_projects = user.subscription.remaining_projects;
                });
        }
    },
    
    hasTrialExpired () {
        
        if (this.user.subscription.start_date) {
            return false;
        }
        if (this.user.subscription.trial_end_date && moment().isAfter(this.user.subscription.trial_end_date)) {
            return true;
        }
        return this.user.subscription.remaining_projects <= 0;
    },
    
    logout () {
        const token = this.getToken();
        
        if (this.user.authenticated && token) {
            this.user.authenticated = false;
            this.user.id = 0;
            this.user.firstName = '';
            this.user.lastName = '';
            this.user.email = '';
        }
        localStorage.removeItem('jwt-token');
        localStorage.removeItem('jwt-token-cal');
        this.removeCookie('jwt-token');
    },
    
    getToken () {
        return localStorage.getItem('jwt-token') || this.getCookie('jwt-token');
    },
    
    setToken (token) {
        localStorage.setItem('jwt-token', token);
        localStorage.setItem('jwt-storage-state', document.location.protocol == 'https:' ? 1 : 2);
        
        return this.getUserInfo(token);
    },
    
    noHttpsToken() {
        if (localStorage.getItem('jwt-storage-state') != 1) {
            this.logout();
        }
        if (location.protocol != 'https:') {
            location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
        }
    },
    
    getCookie (cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    
    removeCookie (name) {
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=.constructalead.com";
    }

}
